<!-- 项目文件 -->
<template>
    <div class="w100p  posre">
        <swiper :options="swiperOption" class="zindex999 w100p swiper-no-swiping">
            <swiper-slide class="w100p h100p ">
                <img class="imgauto" src="../../public/img/img327.png" alt="">
            </swiper-slide>
            <swiper-slide class="w100p h100p ">
                <img class="imgauto" src="../../public/img/img328.png" alt="">
            </swiper-slide>
            <swiper-slide class="w100p h100p ">
                <img class="imgauto" src="../../public/img/img329.png" alt="">
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                swiperOption: { //swiper3
                    autoplayDisableOnInteraction: false,
                    autoplay: {
                        autoplay: 2500,
                    },
                    autoplay: 2500,
                    speed: 1500,
                    loop: true
                }
            };
        },
        methods: {

        },
        created() {

        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>